import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const templateApi = createApi({
  reducerPath: "templateApi",
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Template/`),

  endpoints: (builder) => ({
    downloadTemplate: builder.query({
      query: (id) => ({
        url: `DownloadTemplate?templateId=${id}`,
        method: "GET",
        responseHandler: async (response: any) => {
          // Convert response to blob
          const blob = await response.blob();

          // Extract filename from Content-Disposition header
          const contentDisposition = response.headers.get(
            "content-disposition"
          );

          let fileName = "template.xlsx"; // Default filename

          // Check if content-disposition header exists and contains a filename
          if (contentDisposition) {
            // Match either filename= or filename*=UTF-8'' patterns
            const match = contentDisposition.match(
              /filename\*?=['"]?UTF-8''?([^;'\n]*)/i
            );
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
          }

          // Return blob and filename for use in UI
          return { blob, fileName };
        },
      }),
    }),
  }),
});

export const { useDownloadTemplateQuery, useLazyDownloadTemplateQuery } =
  templateApi;
export default templateApi.reducer;
